export enum ChainName {
  ETHEREUM = 'ETHEREUM',
  ALGORAND = 'ALGORAND',
  STELLAR = 'STELLAR'
}
